const navList = [
    {text: 'ABOUT', id: 'provid'},
    {text: 'TEAM', id: 'work'},
    {text: 'PORTFOLIO', id: 'our-partner'},
]
export {navList}
